import { env } from './env';

export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
  },

  auth: {
    login: {
      path: '/login',
      getHref: (redirectTo?: string) => `/login${redirectTo ? `?redirectTo=${redirectTo}` : ''}`,
    },
    logout: {
      path: '/logout',
      getHref: () => '/logout',
    },
    callback: {
      path: env.OIDC_CALLBACK_PATH,
      getHref: () => env.OIDC_CALLBACK_PATH,
    },
  },

  onboarding: {
    path: 'onboarding',
    getHref: () => '/o/onboarding',
  },

  error: {
    path: '/error',
    getHref: () => '/error',
  },

  org: {
    root: {
      path: '/o',
      getHref: () => '/o',
    },
    userProfile: {
      path: 'profile',
      getHref: () => '/o/profile',
    },
    selectedOrg: {
      path: ':orgId',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    dashboard: {
      path: '',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    users: {
      path: 'users',
      getHref: (orgId: string) => `/o/${orgId}/users`,
    },
    user: {
      path: 'users/:userId',
      getHref: (orgId: string, userId: string) => `/o/${orgId}/users/${userId}`,
    },
    roles: {
      path: 'roles',
      getHref: (orgId: string) => `/o/${orgId}/roles`,
    },
    activity: {
      path: 'activity',
      getHref: (orgId: string) => `/o/${orgId}/activity`,
    },
    role: {
      path: 'roles/:roleId',
      getHref: (orgId: string, roleId: string) => `/o/${orgId}/roles/${roleId}`,
    },
    orgProfile: {
      path: 'org-profile',
      getHref: (orgId: string) => `/o/${orgId}/org-profile`,
    },
    projectsList: {
      path: 'projects',
      getHref: (orgId: string) => `/o/${orgId}/projects`,
    },
    project: {
      root: {
        path: 'projects/:projectId',
        getHref: (orgId: string, projectId: string) => `/o/${orgId}/projects/${projectId}`,
      },
      dashboard: {
        path: '',
        getHref: (orgId: string, projectId: string) => `/o/${orgId}/projects/${projectId}`,
      },
      users: {
        path: 'users',
        getHref: (orgId: string, projectId: string) => `/o/${orgId}/projects/${projectId}/users`,
      },
      user: {
        path: 'users/:userId',
        getHref: (orgId: string, projectId: string, userId: string) =>
          `/o/${orgId}/projects/${projectId}/users/${userId}`,
      },
      buildings: {
        path: 'buildings',
        getHref: (orgId: string, projectId: string) =>
          `/o/${orgId}/projects/${projectId}/buildings`,
      },
      building: {
        path: 'buildings/:buildingId',
        getHref: (orgId: string, projectId: string, buildingId: string) =>
          `/o/${orgId}/projects/${projectId}/buildings/${buildingId}`,
      },
      systems: {
        path: 'systems',
        getHref: (orgId: string, projectId: string) => `/o/${orgId}/projects/${projectId}/systems`,
      },
      room: {
        path: 'room',
        getHref: (orgId: string, projectId: string) => `/o/${orgId}/projects/${projectId}/room`,
      },
      system: {
        path: 'system',
        getHref: (orgId: string, projectId: string) => `/o/${orgId}/projects/${projectId}/system`,
      },
      reports: {
        path: 'reports',
        getHref: (orgId: string, projectId: string) => `/o/${orgId}/projects/${projectId}/reports`,
      },
      settings: {
        path: 'settings',
        getHref: (orgId: string, projectId: string) => `/o/${orgId}/projects/${projectId}/settings`,
      },
      activity: {
        path: 'activity',
        getHref: (orgId: string, projectId: string) => `/o/${orgId}/projects/${projectId}/activity`,
      },
      powerTypes: {
        path: 'power-types',
        getHref: (orgId: string, projectId: string) =>
          `/o/${orgId}/projects/${projectId}/power-types`,
      },
    },
    itemTemplates: {
      path: 'item-templates',
      getHref: (orgId: string) => `/o/${orgId}/item-templates`,
    },
    itemTemplate: {
      path: 'item-templates/:itemTemplateId',
      getHref: (orgId: string, itemTemplateId: string) =>
        `/o/${orgId}/item-templates/${itemTemplateId}`,
    },
    itemTemplateSchema: {
      path: 'item-templates/:itemTemplateId/schema',
      getHref: (orgId: string, itemTemplateId: string) =>
        `/o/${orgId}/item-templates/${itemTemplateId}/schema`,
    },
    settings: {
      path: 'settings',
      getHref: (orgId: string) => `/o/${orgId}/settings`,
    },
  },

  app: {
    root: {
      path: '',
      getHref: () => '/admin',
    },
    dashboard: {
      path: '',
      getHref: () => '/admin',
    },
    users: {
      path: 'users',
      getHref: () => '/admin/users',
    },
    orgs: {
      path: 'orgs',
      getHref: () => '/admin/orgs',
    },
    roles: {
      path: 'roles',
      getHref: () => '/admin/roles',
    },
    profile: {
      path: 'profile',
      getHref: () => '/admin/profile',
    },
    user: {
      path: 'user/:userId',
      getHref: (userId: string) => `/admin/user/${userId}`,
    },
    apps: {
      path: 'apps',
      getHref: () => '/admin/apps',
    },
    app: {
      path: 'apps/:appId',
      getHref: (appId: string) => `/admin/apps/${appId}`,
    },
  },
} as const;
